///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

import ActiveBidsList from "./ActiveBidsList";

import * as types from "../helpers/types";

const statusToBidsPropMap = {
  [types.status.pending]: "pendingBids",
  [types.status.inProgress]: "inProgressBids",
  [types.status.submitted]: "submittedBids",
  [types.status.feedback]: "feedbackBids"
};

const selectFilteredBids = status =>
  createSelector(
    state => state.activeBids[statusToBidsPropMap[status]],
    bids => bids.filter(bid => bid.matchesSearch)
  );

const ActiveBidsCardView = ({ activeBids }) => {
  const filteredPendingBids = useSelector(
    selectFilteredBids(types.status.pending)
  );
  const filteredInProgressBids = useSelector(
    selectFilteredBids(types.status.inProgress)
  );
  const filteredSubmittedBids = useSelector(
    selectFilteredBids(types.status.submitted)
  );
  const filteredFeedbackBids = useSelector(
    selectFilteredBids(types.status.feedback)
  );

  return (
    <article
      id="active-bids"
      className="flex flex-col pb-20"
      data-testid="active-bids-card-view"
    >
      <div
        id="active-bids-lists"
        className="flex flex-auto flex-wrap justify-between pos-relative"
      >
        <ActiveBidsList
          bids={filteredPendingBids}
          isFetching={activeBids.isFetching}
          key={types.status.pending}
          status={types.status.pending}
          sortByRfqCloseDate={activeBids.filters.sortByRfqCloseDate}
        />
        <ActiveBidsList
          bids={filteredInProgressBids}
          isFetching={activeBids.isFetching}
          key={types.status.inProgress}
          status={types.status.inProgress}
          sortByRfqCloseDate={activeBids.filters.sortByRfqCloseDate}
        />
        <ActiveBidsList
          bids={filteredSubmittedBids}
          isFetching={activeBids.isFetching}
          key={types.status.submitted}
          status={types.status.submitted}
          sortByRfqCloseDate={activeBids.filters.sortByRfqCloseDate}
        />
        <ActiveBidsList
          bids={filteredFeedbackBids}
          isFetching={activeBids.isFetching}
          key={types.status.feedback}
          status={types.status.feedback}
          sortByRfqCloseDate={activeBids.filters.sortByRfqCloseDate}
        />
      </div>
    </article>
  );
};

export default ActiveBidsCardView;
